export default __webpack_public_path__ + "static/media/originalHives.6b43373b.jpg";